import { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../redux/actions';

// WON/LOST ไม่ใช่ตัวเลือกใน dropdown นี้แล้ว (ดู getSelectableStatuses) เลยไม่ต้อง
// จัดการ poNumber ที่นี่อีก — ไปกรอกที่ปุ่ม "จบงาน" (useFinishJob) แทน
export function useStatusChange({ opportunity, onChanged, showSnack }) {
  const dispatch = useDispatch();
  const [statusDialog, setStatusDialog] = useState({ open: false, toStatus: '', note: '' });
  const [saving, setSaving] = useState(false);

  const openStatusDialog = (toStatus) => setStatusDialog({ open: true, toStatus, note: '' });
  const closeStatusDialog = () => setStatusDialog({ open: false, toStatus: '', note: '' });
  const setNote = (note) => setStatusDialog((p) => ({ ...p, note }));

  const handleStatusChange = async () => {
    setSaving(true);
    try {
      await dispatch(actions.changeOpportunityStatus({
        id: opportunity.id,
        toStatus: statusDialog.toStatus,
        note: statusDialog.note || undefined,
      }));
      showSnack('เปลี่ยนสถานะสำเร็จ');
      closeStatusDialog();
      onChanged();
    } catch (err) {
      showSnack(err.message || 'เปลี่ยนสถานะไม่สำเร็จ', 'error');
    } finally {
      setSaving(false);
    }
  };

  return {
    statusDialog, saving, openStatusDialog, closeStatusDialog, setNote, handleStatusChange,
  };
}

export default useStatusChange;
